import React, { FC, useEffect, useState } from "react";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import {
  Col,
  Form,
  Input,
  Upload,
  Row,
  Select,
  Spin,
  notification,
  Switch,
  Space,
} from "antd";
import styled from "styled-components";
import { SmallText } from "../../../Components/Text3D";
import MultiplyIcon from "../../../assets/images/multiply.png";
import { Button3D, PrimaryButtonX } from "../../../Components/Button3D";
import { CaretDownOutlined, DeleteOutlined } from "@ant-design/icons";
import { GENERATE_PRE_SIGNED_URL_MUTATION } from "../../../Apollo/graphql/Mutation/UploadFile";
import { uploadtoS3 } from "../../../helper/uploadFile";
import { CREATE_PRINTER } from "../../../Apollo/graphql/Mutation/PrintersMutations/CreatePrinter";
import { GET_SHIPPING_POSTAL_SEARCH } from "../../../Apollo/graphql/Query";
import { GET_SHIPPING_COUNTRIES } from "../../../Apollo/graphql/Query/GetShippingCountrys";
import { neededColors } from "../../../helper/NeededColors";
import { replaceError } from "../../../utils/utilsFunctions";

const { Option } = Select;

const MainWrapper = styled(Row)`
  /* &:before{
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 360px;
    } */
`;

const ContentSection = styled(Col)`
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;
const Img = styled.img`
  margin-top: -10px;
  align-self: center;
`;
const InputA = styled(Input)`
  // margin-top: 0.8rem;
  height: 60px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
`;
const FilamentDiv = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  border: 1px solid black;
  padding: 2rem;
  width: fit-content;
  max-width: 90vw;
`;
const SelectX = styled(Select)`
  .ant-select-selector {
    height: 60px !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector {
    height: 60px;
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin-top: 3rem;
  .hero{
    display: flex;

    @media screen and (max-width: 768px){
    flex-flow: column;
  }
  }

  @media screen and (max-width: 768px){
    flex-flow: column;
  }
`

const AddNewPrinter: FC = () => {
  const [uploadFileMutation] = useMutation(GENERATE_PRE_SIGNED_URL_MUTATION);
  const [createPrinter] = useMutation(CREATE_PRINTER);
  const [printerImages, setPrinterImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [filamentList, setFilamentList] = useState<any>([
    { name: "", price: "", colors: [] },
  ]);
  const [selectedCountry, setSelectedCountry] = useState<any>("");
  const [address, setAddress] = useState<any>();
  const [country, setCountry] = useState<any>();
  const { data: searchCountries } = useQuery(GET_SHIPPING_COUNTRIES);

  const [
    searchData,
    { data: searchD, loading: searchLoading, error: serchError },
  ] = useLazyQuery(GET_SHIPPING_POSTAL_SEARCH, {});

  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({
      status: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAddNewClick = () => {
    setFilamentList([...filamentList, { price: "", name: "", colors: [] }]);
  };
  const handleFilamentChange = (e, idx, key) => {
    filamentList[idx][key] = e;
    setFilamentList([...filamentList]);
  };

  const handleDeleteFList = (idx) => {
    const List = [...filamentList];
    List.splice(idx, 1);
    setFilamentList(List);
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      let printerImagesFinalUrl: any = [];
      let finalFilamentList: any = filamentList;
      let filamentApproved = true;
      for (let i = 0; i < finalFilamentList.length; i++) {
        if (
          finalFilamentList[i] &&
          (!finalFilamentList[i].name || !finalFilamentList[i].price)
        ) {
          filamentApproved = false;
        }
      }
      if (!filamentApproved) {
        notification.error({
          message: "Error",
          description: "Filament material and price cannot be empty!",
        });
        setLoading(false);
      } else {
        // Upload all printer image to s3
        for (let i = 0; i < printerImages.length; i++) {
          let singleFile: any = printerImages[i];
          setLoading(true);
          try {
            const {
              data: {
                generate3dPreSignedURL: { url },
              },
            } = await uploadFileMutation({
              variables: {
                input: {
                  type: "put",
                  fileId: singleFile.uid,
                  mime: singleFile.type,
                },
              },
            });
            if (url) {
              const result = await uploadtoS3(url, singleFile.originFileObj, 1);
              if (result) {
                setLoading(false);
                printerImagesFinalUrl.push(url.split("?")[0]);
              }
            }
          } catch (err) {
            setLoading(false);
            notification.error({
              message: "Error",
              description: replaceError(err),
            });
          }
        }
        setLoading(false);
        const printerResult = await createPrinter({
          variables: {
            input: {
              name: values.name,
              brand: values.brand,
              length: Number(values.length),
              height: Number(values.height),
              width: Number(values.width),
              featuredImage: thumbnailUrl,
              images: printerImagesFinalUrl,
              active: values.status,
              filaments: filamentList,
              description: values.description,
              countryCode:
                selectedCountry === "overseas" ? values.country : "AU",
              country:
                selectedCountry === "overseas"
                  ? country?.key
                  : selectedCountry.toUpperCase(),
              postalAddress:
                selectedCountry === "australia"
                  ? address?.children?.toString().replace(/,/g, "")
                  : null,
              postServiceCode:
                selectedCountry === "australia"
                  ? values.address.split("_")[0]
                  : values.postServiceCode,
              postalState: values.postalState,
              postalCity: values.postalCity,
              postalStreet: values.postalStreet,
            },
          },
        });
        if (printerResult) {
          notification.success({
            message: "Success",
            description: "Printer added successfully",
          });
          window.location.replace("/dashboard/printers");
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Error",
        description: replaceError(error),
      });
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    notification.info({
      message: "Info",
      description: "Please fill all the required fields",
    });
  };
  // thumbnail
  const thumbNailProps = {
    name: "file",
    multiple: false,
    beforeUpload: async (file: any) => {
      setLoading(true);
      try {
        const {
          data: {
            generate3dPreSignedURL: { url },
          },
        } = await uploadFileMutation({
          variables: {
            input: {
              type: "put",
              fileId: file.uid,
              mime: file.type,
            },
          },
        });
        if (url) {
          uploadtoS3(url, file, 1)
            .then((data) => {
              setThumbnailUrl(url.split("?")[0]);
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
            });
        }
      } catch (err) {
        setLoading(false);
      }
      return false;
    },
  };

  // printer images
  const imageProps = {
    name: "file",
    multiple: true,
    onChange: (info) => {
      setPrinterImages(info.fileList);
    },
  };
  const handleInputSearch = (searchquery) => {
    if (searchquery.length >= 3) {
      searchData({
        variables: {
          search: searchquery,
        },
      });
    }
  };

  const handleLocationChange = (value) => {
    setSelectedCountry(value);
     form.setFieldsValue({
       countryCode: null,
       postalAddress: null,
       postServiceCode: null,
       postalState: null,
       postalCity: null,
       postalStreet: null,
       country: null,
     });
  }

  return (
    <Spin spinning={loading}>
      <MainWrapper>
        <ContentSection>
          <SmallText size line bold style={{ padding: "2rem 0" }}>
            add new printer
          </SmallText>
          <Form
            form={form}
            labelCol={{ span: 24 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
              ]}
            >
              <InputA placeholder="Printer Name" style={{ width: "45%" }} />
            </Form.Item>
            <Form.Item
              label="Brand"
              name="brand"
              rules={[
                {
                  required: true,
                  message: "Brand is required",
                },
              ]}
            >
              <InputA placeholder="Brand Name" style={{ width: "45%" }} />
            </Form.Item>

            <Form.Item label="Dimension( L x W x H) in mm">
              <Space style={{ display: "flex", width: "100%" }}>
                <Form.Item
                  label=""
                  name="length"
                  rules={[
                    {
                      required: true,
                      message: "Length is required",
                    },
                  ]}
                >
                  <InputA placeholder="200" type="number" />
                </Form.Item>
                <Img src={MultiplyIcon} alt=""></Img>
                <Form.Item
                  label=""
                  name="width"
                  rules={[
                    {
                      required: true,
                      message: "Width is required",
                    },
                  ]}
                >
                  <InputA placeholder="200" type="number" />
                </Form.Item>
                <Img src={MultiplyIcon} alt=""></Img>
                <Form.Item
                  label=""
                  name="height"
                  rules={[
                    {
                      required: true,
                      message: "Height is required",
                    },
                  ]}
                >
                  <InputA placeholder="200" type="number" />
                </Form.Item>
              </Space>
            </Form.Item>
            <div style={{ display: "flex", flexFlow: "row" }}>
              <Form.Item
                label="Printer location"
                name="location"
                rules={[
                  {
                    required: true,
                    message: "Printer location is required",
                  },
                ]}
              >
                <SelectX
                  size="large"
                  placeholder="Select the country"
                  defaultActiveFirstOption={false}
                  style={{ width: 200 }}
                  filterOption={false}
                  dropdownMatchSelectWidth={false}
                  onChange={(value) => handleLocationChange(value)}
                  notFoundContent={null}
                >
                  <Option value="australia">Australia</Option>
                  <Option value="overseas">Overseas</Option>
                </SelectX>
              </Form.Item>
              {selectedCountry && selectedCountry === "australia" && (
                <Form.Item
                  label="Post/Zip code"
                  name="address"
                  style={{ marginLeft: "1rem" }}
                  rules={[
                    {
                      required: true,
                      message: "Please select postal address",
                    },
                  ]}
                >
                  <SelectX
                    size="large"
                    showSearch
                    placeholder="Search"
                    defaultActiveFirstOption={false}
                    dropdownMatchSelectWidth={false}
                    style={{ width: 200 }}
                    disabled={selectedCountry === "overseas"}
                    filterOption={false}
                    onSearch={handleInputSearch}
                    onChange={(e, obj) => setAddress(obj)}
                    notFoundContent={null}
                  >
                    {searchLoading && (
                      <Option value="search" disabled={true}>
                        Searching....
                      </Option>
                    )}
                    {serchError && (
                      <Option value="error" disabled={true}>
                        data not found
                      </Option>
                    )}
                    {searchD &&
                      searchD?.shippingPostalSearch?.map((s) => (
                        <Option key={s.id} value={`${s.postcode}_${s.id}`}>
                          {s.location} {s.state} {s.postcode}
                        </Option>
                      ))}
                  </SelectX>
                </Form.Item>
              )}
              {selectedCountry && selectedCountry === "overseas" && (
                <>
                  <Form.Item
                    label="Country"
                    name="country"
                    style={{ marginLeft: "1rem" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select country",
                      },
                    ]}
                  >
                    <SelectX
                      size="large"
                      placeholder="Search"
                      defaultActiveFirstOption={false}
                      style={{ width: 200 }}
                      dropdownMatchSelectWidth={false}
                      filterOption={false}
                      onChange={(e, obj) => setCountry(obj)}
                      notFoundContent={null}
                    >
                      {searchCountries &&
                        searchCountries?.shippingCountries?.map((s) => (
                          <Option key={s.name} value={s.code}>
                            {s.name}
                          </Option>
                        ))}
                    </SelectX>
                  </Form.Item>
                  <Form.Item
                    label="Post/Zip code"
                    name="postServiceCode"
                    rules={[
                      {
                        required: true,
                        message: "Post/Zip code is required",
                      },
                    ]}
                  >
                    <InputA
                      placeholder=""
                      name="postServiceCode"
                      style={{ width: "45%" }}
                    />
                  </Form.Item>
                </>
              )}
            </div>
            <Form.Item
              label="City"
              name="postalCity"
              rules={[
                {
                  required: true,
                  message: "City is required",
                },
              ]}
            >
              <InputA
                placeholder=""
                name="postalCity"
                style={{ width: "45%" }}
              />
            </Form.Item>
            <Form.Item
              label="State"
              name="postalState"
              rules={[
                {
                  required: true,
                  message: "State is required",
                },
              ]}
            >
              <InputA
                placeholder=""
                name="postalState"
                style={{ width: "45%" }}
              />
            </Form.Item>
            <Form.Item
              label="Street Address"
              name="postalStreet"
              rules={[
                {
                  required: true,
                  message: "Street Address is required",
                },
              ]}
            >
              <InputA
                placeholder=""
                name="postalStreet"
                style={{ width: "45%" }}
              />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Switch
                checkedChildren="active"
                unCheckedChildren="inactive"
                defaultChecked
              />
            </Form.Item>

            <Form.Item
              label="Materials and Pricing"
              style={{ width: "100%", display: "flex" }}
            >
              <FilamentDiv>
                {filamentList.map((s, idx) => (
                  <div
                    key={idx}
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: "2rem",
                    }}
                  >
                    <Form.Item style={{ width: "150px" }}>
                      <SelectX
                        style={{ marginRight: "2rem", height: "60px" }}
                        suffixIcon={<CaretDownOutlined />}
                        placeholder="material"
                        optionFilterProp="children"
                        dropdownMatchSelectWidth={false}
                        onChange={(e) => handleFilamentChange(e, idx, "name")}
                      >
                        <Option value="ABS">ABS</Option>
                        <Option value="PLA">PLA</Option>
                        <Option value="PLA_PLUS">PLA+</Option>
                        <Option value="PET">PET</Option>
                        <Option value="PETG">PETG</Option>
                        <Option value="RESIN">RESIN</Option>
                        <Option value="NYLON">NYLON</Option>
                        <Option value="NYLON_CARBON_FIBER">
                          NYLON CARBON FIBER
                        </Option>
                        <Option value="TPU">TPU</Option>
                        <Option value="HIPS">HIPS</Option>
                        <Option value="PVA">PVA</Option>
                        <Option value="SANDSTONE">SANDSTONE</Option>
                        <Option value="CERAMICS">CERAMICS</Option>
                        <Option value="STEEL">STEEL</Option>
                        <Option value="WOOD">WOOD</Option>
                        <Option value="POLYCARBONATE">POLYCARBONATE</Option>
                      </SelectX>
                    </Form.Item>
                    <Form.Item style={{ marginLeft: "2rem", width: "150px" }}>
                      <InputA
                        placeholder="Price $/gram"
                        style={{ marginTop: "0px" }}
                        type="number"
                        // min='0'
                        // value={s.price}
                        onChange={(e) =>
                          handleFilamentChange(
                            Number(e.target.value),
                            idx,
                            "price"
                          )
                        }
                      />
                    </Form.Item>
                    <Form.Item style={{ width: "150px", marginLeft: "2rem" }}>
                      <SelectX
                        placeholder="Choose color"
                        mode="multiple"
                        // showArrow
                        onChange={(e) => handleFilamentChange(e, idx, "colors")}
                        style={{ marginTop: "0px" }}
                        maxTagCount="responsive"
                      >
                        {neededColors.map((it) => (
                          <Option value={it}>{it}</Option>
                        ))}
                      </SelectX>
                    </Form.Item>
                    {filamentList.length > 1 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "2rem",
                          marginTop: "-20px",
                        }}
                      >
                        <DeleteOutlined
                          onClick={() => handleDeleteFList(idx)}
                        />
                      </div>
                    )}
                  </div>
                ))}
                <PrimaryButtonX
                  type="primary"
                  onClick={handleAddNewClick}
                  style={{ marginTop: "1rem" }}
                >
                  Add More
                </PrimaryButtonX>
              </FilamentDiv>
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={4} />
            </Form.Item>
            <ButtonGroup>
              <div className="hero">
                <Form.Item
                  name="thumbnailUrl"
                  rules={[
                    {
                      required: true,
                      message: "please select thumbnail image",
                    },
                  ]}
                >
                  <Upload
                    listType="picture"
                    {...thumbNailProps}
                    accept=".png, .svg, .jpg, .jpeg"
                  >
                    <Button3D type="primary" style={{ marginRight: "1.5rem" }}>
                      upload thumbnail
                    </Button3D>
                  </Upload>
                </Form.Item>
                <Form.Item>
                  <Upload
                    listType="picture"
                    {...imageProps}
                    accept=".png, .jpg, .jpeg"
                  >
                    <Button3D style={{ border: "2px solid #1196DD" }}>
                      upload images
                    </Button3D>
                  </Upload>
                </Form.Item>
              </div>
              <Form.Item>
                <Button3D
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "rgba(9, 185, 79, 1)",
                    marginLeft: "1.5rem",
                  }}
                >
                  save
                </Button3D>
              </Form.Item>
            </ButtonGroup>
          </Form>
        </ContentSection>
      </MainWrapper>
    </Spin>
  );
};

export default AddNewPrinter;
